import { useEffect, useState } from "react";
import "../styles/ScrollToTop.css";

const ScrollToTop = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      className="scroll-to-top-context"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Scroll to top"
    >
      <img
        src="/images/arrow-up.png"   
        alt="Scroll to top"
        className="scroll-up-img"
      />
    </button>
  );
};

export default ScrollToTop;
